import ecom from "../../../Assets/image/domain-section/e-com.webp";
import edu from "../../../Assets/image/domain-section/education.webp";
import entertainment from "../../../Assets/image/domain-section/entertainment.webp";
import health from "../../../Assets/image/domain-section/health.webp";
import finance from "../../../Assets/image/domain-section/finance.webp";
import travel from "../../../Assets/image/domain-section/travel.webp";

const domainData = [
  {
    id: 1,
    title: "E-commerce",
    gradient: "from-sky-900/90 to-sky-900/20",
    image: ecom,
  },
  {
    id: 2,
    title: "Education",
    gradient: "from-green-900/90 to-green-900/20",
    image: edu,
  },
  {
    id: 3,
    title: "Entertainment",
    gradient: "from-purple-900/90 to-purple-900/20",
    image: entertainment,
  },
  {
    id: 4,
    title: "Healthcare",
    gradient: "from-teal-900/90 to-teal-900/20",
    image: health,
  },
  {
    id: 5,
    title: "Finance",
    gradient: "from-yellow-900/90 to-yellow-900/20",
    image: finance,
  },
  {
    id: 6,
    title: "Travel",
    gradient: "from-orange-900/90 to-orange-900/20",
    image: travel,
  },
];

export default domainData;
